/* import __COLOCATED_TEMPLATE__ from './fly-popup.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { isNone } from '@ember/utils';
import { schedule } from '@ember/runloop';
let FlyPopup = (_class = class FlyPopup extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "computedDirection", _descriptor, this);
    _initializerDefineProperty(this, "style", _descriptor2, this);
  }
  get wrapperClass() {
    return this.args.wrapperClass ?? 'fly-popup';
  }
  get verticalMargin() {
    return this.args.verticalMargin ?? 200;
  }
  get horizontalMargin() {
    return this.args.horizontalMargin ?? 250;
  }
  get directionClass() {
    return `${this.wrapperClass}--${this.computedDirection}`;
  }
  get colorClass() {
    if (!this.args.color) {
      return '';
    }
    return `${this.wrapperClass}--${this.args.color}`;
  }
  onMouseEnter() {
    if (this.args.onMouseEnter) {
      this.args.onMouseEnter();
    }
  }
  onMouseLeave() {
    if (this.args.onMouseLeave) {
      this.args.onMouseLeave();
    }
  }
  onEdgeOffset(direction, triggerWidth) {
    if (this.args.onEdgeOffset) {
      this.args.onEdgeOffset(direction, triggerWidth);
    }
  }
  updateStyle(element) {
    let coordinates = this.calculateCoordinates();
    let popupRect = element.getBoundingClientRect();
    let xPosition;
    let {
      computedDirection: direction
    } = this;
    if (direction === 'top' || direction === 'bottom') {
      // document.body.offsetWidth gives us the width of the window without
      // the scrollbar (if present)
      let width = document.body.offsetWidth + document.body.scrollLeft;
      let triggerCenter = coordinates.left;
      let spaceOnRight = width - triggerCenter;
      let spaceOnLeft = triggerCenter;
      if (spaceOnRight < popupRect.width / 2) {
        let {
          triggerWidth
        } = coordinates;

        // align popup right edge with trigger right edge
        xPosition = coordinates.left - popupRect.width + triggerWidth / 2;
        this.onEdgeOffset('right', triggerWidth);
      } else if (spaceOnLeft < popupRect.width / 2) {
        let {
          triggerWidth
        } = coordinates;

        // align popup left edge with trigger left edge
        xPosition = coordinates.left - triggerWidth / 2;
        this.onEdgeOffset('left', triggerWidth);
      }
    }
    if (isNone(xPosition)) {
      xPosition = coordinates.left + popupRect.width * coordinates.x;
    }
    let yPosition = coordinates.top + popupRect.height * coordinates.y;
    this.style = htmlSafe(`
      position: absolute;
      top: ${yPosition}px;
      left: ${xPosition}px;
      width: fit-content;
      visibility: visible;
      opacity: 1;
    `);
  }
  computeDirectionAndUpdateStyle(element) {
    this.computedDirection = this.computeDirection(element);

    // Need to run this after the popup has been wormholed, otherwise the
    // dimensions of the popup won't be correct.
    schedule('afterRender', this, () => {
      this.updateStyle(element);
    });
  }
  calculateCoordinates() {
    let trigger = this.args.findAnchor();
    let rect = trigger.getBoundingClientRect();
    let {
      top,
      left,
      height,
      width
    } = rect;

    // If the user has scrolled, add the scroll offsets so that the tooltip is
    // positioned correctly with the trigger.
    top += window.scrollY ?? 0;
    left += window.scrollX ?? 0;
    let {
      computedDirection: direction
    } = this;
    switch (direction) {
      case 'top':
        return {
          top: Math.round(top),
          left: Math.round(left + width / 2),
          triggerWidth: width,
          x: -0.5,
          y: -1
        };
      case 'right':
        return {
          top: Math.round(top + height / 2),
          left: Math.round(left + width),
          triggerWidth: width,
          x: 0,
          y: -0.5
        };
      case 'bottom':
        return {
          top: Math.round(top + height),
          left: Math.round(left + width / 2),
          triggerWidth: width,
          x: -0.5,
          y: 0
        };
      case 'left':
        return {
          top: Math.round(top + height / 2),
          left: Math.round(left),
          triggerWidth: width,
          x: -1,
          y: -0.5
        };
      case 'top-left':
        return {
          top: Math.round(top),
          left: Math.round(left),
          triggerWidth: width,
          x: -1,
          y: -1
        };
      case 'top-right':
        return {
          top: Math.round(top),
          left: Math.round(left + width),
          triggerWidth: width,
          x: 0,
          y: -1
        };
      case 'bottom-left':
        return {
          top: Math.round(top + height),
          left: Math.round(left),
          triggerWidth: 0,
          x: -1,
          y: 0
        };
      case 'bottom-right':
        return {
          top: Math.round(top + height),
          left: Math.round(left + width),
          triggerWidth: 0,
          x: 0,
          y: 0
        };
      default:
        return {
          top: 0,
          left: 0,
          x: 0,
          y: 0,
          triggerWidth: 0
        };
    }
  }
  computeDirection(element) {
    let trigger = this.args.findAnchor();
    let rect = trigger.getBoundingClientRect();
    let edgeDistances = {
      top: rect.top,
      right: window.innerWidth - rect.right,
      bottom: window.innerHeight - rect.bottom,
      left: rect.left
    };
    let elementRect = element.getBoundingClientRect();
    let parentHeight = window.innerHeight;
    let parentWidth = window.innerWidth;
    let {
      verticalMargin,
      horizontalMargin
    } = this;
    let {
      scrollLeft,
      scrollTop
    } = trigger;
    let topBound = scrollTop + verticalMargin;
    let bottomBound = scrollTop + parentHeight - rect.height - verticalMargin;
    let leftBound = scrollLeft + horizontalMargin;
    let rightBound = scrollLeft + parentWidth - rect.width - horizontalMargin;
    let {
      direction
    } = this.args;
    if (isNone(direction)) {
      direction = 'bottom';
    }
    if (direction.includes('top') && (rect.top < topBound || edgeDistances.top < elementRect.height)) {
      direction = direction.replace('top', 'bottom');
    }
    if (direction.includes('bottom') && (rect.top > bottomBound && rect.top >= topBound || edgeDistances.bottom < elementRect.height)) {
      direction = direction.replace('bottom', 'top');
    }
    if (direction.includes('left') && (rect.left < leftBound || edgeDistances.left < elementRect.width)) {
      direction = direction.replace('left', 'right');
    }
    if (direction.includes('right') && rect.left > rightBound && rect.left >= leftBound || edgeDistances.right < elementRect.width) {
      direction = direction.replace('right', 'left');
    }
    return direction;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "computedDirection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.direction ?? 'top';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "style", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return htmlSafe('position: absolute; top: 0; left: 0; visibility: hidden; opacity: 0;');
  }
}), _applyDecoratedDescriptor(_class.prototype, "onMouseEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseLeave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseLeave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEdgeOffset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEdgeOffset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateStyle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "computeDirectionAndUpdateStyle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "computeDirectionAndUpdateStyle"), _class.prototype)), _class);
export { FlyPopup as default };